export default __webpack_public_path__ + "static/media/eventSlide1.59a33dbb.png";